// extracted by mini-css-extract-plugin
module.exports = {"bodyLock":"body-lock-module--body-lock--3BQXN"};